"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable class-methods-use-this */
const BaseBuyProvider_1 = require("../BaseBuyProvider");
const cryptos_1 = __importDefault(require("./cryptos"));
const fiats_1 = __importDefault(require("./fiats"));
const countries_1 = __importDefault(require("./countries"));
const paymentOptions_1 = __importDefault(require("./paymentOptions"));
const banxa_png_1 = __importDefault(require("../../../../static/providers/banxa.png"));
const fiatRates_1 = require("../../helpers/fiatRates");
const constants_1 = require("./constants");
// import { BANXA_BEARER_TOKEN_SANDBOX } from "../../data/apiKeys";
/**
 * https://docs.banxa.com/reference
 */
class BanxaProvider {
    constructor() {
        this.id = "banxa";
        this.name = "Banxa";
        this.logo = banxa_png_1.default;
        this.defaultFiatCurrency = "USD";
        this.addressPassthrough = true;
    }
    getPaymentMethods(fiat, crypto) {
        return __awaiter(this, void 0, void 0, function* () {
            const formatted = paymentOptions_1.default
                .filter((i) => i.supported_fiat.includes(fiat) && i.supported_coin.includes(crypto))
                .map((i) => i.paymentType);
            const reducedPaymentOptions = formatted.reduce((prev, payment) => {
                const foundOption = constants_1.PAYMENT_OPTIONS.find((val) => val.id === payment);
                if (foundOption) {
                    return [...prev, foundOption];
                }
                return prev;
            }, []);
            return reducedPaymentOptions;
        });
    }
    getAvailability(countryData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!countryData)
                return false;
            return (yield this.getSupportedCountries()).includes(countryData.alpha2.toUpperCase());
        });
    }
    getSupportedCryptos() {
        return __awaiter(this, void 0, void 0, function* () {
            return cryptos_1.default.reduce((p, c) => [...p, c.coin_code], []);
        });
    }
    getSupportedFiat() {
        return __awaiter(this, void 0, void 0, function* () {
            return fiats_1.default.reduce((p, c) => [...p, c.fiat_code], []);
        });
    }
    getSupportedCountries() {
        return __awaiter(this, void 0, void 0, function* () {
            return countries_1.default.reduce((p, c) => [...p, c.country_code], []);
        });
    }
    getBuyQuote(cryptoCode, fiatCode, fiatAmount) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const paymentOptions = yield this.getPaymentMethods(fiatCode, cryptoCode);
                const isRequestedCurrency = (yield this.getSupportedFiat()).includes(fiatCode);
                const currencyCode = isRequestedCurrency
                    ? fiatCode.toUpperCase()
                    : this.defaultFiatCurrency;
                const convertedRate = isRequestedCurrency
                    ? fiatAmount
                    : Math.ceil(yield (0, fiatRates_1.convertFiatRate)(currencyCode, fiatCode, fiatAmount));
                const responseData = {
                    cryptoAmount: -1,
                    fiatAmount: convertedRate,
                    provider: this.id,
                    rate: -1,
                    isRequestedCurrency,
                    paymentOptions,
                    fiatCode: currencyCode,
                };
                return responseData;
            }
            catch (error) {
                console.log("error getting banxa quote", error);
                return BaseBuyProvider_1.DEFAULT_ERROR;
            }
        });
    }
    getSellQuote(cryptoCode, fiatCode, cryptoAmount
    // geoLocation?: CountryDataType | undefined
    ) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const isRequestedCurrency = (yield this.getSupportedFiat()).includes(fiatCode);
                const currencyCode = isRequestedCurrency
                    ? fiatCode
                    : this.defaultFiatCurrency;
                const responseData = {
                    provider: this.id,
                    cryptoAmount,
                    fiatAmount: -1,
                    fiatCode: currencyCode,
                    isRequestedCurrency,
                    rate: -1,
                };
                return responseData;
            }
            catch (error) {
                console.log("Error getting Banxa Sell quote", error);
                return BaseBuyProvider_1.DEFAULT_ERROR;
            }
        });
    }
}
exports.default = BanxaProvider;
//# sourceMappingURL=Banxa.js.map